var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09325 5.28C9.06239 5.24486 9.02448 5.21661 8.98198 5.19709C8.93948 5.17756 8.89335 5.1672 8.84659 5.16667H6.33325V4.22667C6.33325 4.04 6.37325 3.82667 6.67325 3.82667H8.67325C8.71715 3.82854 8.76091 3.82052 8.8013 3.80322C8.84168 3.78591 8.87767 3.75975 8.90659 3.72667C8.96536 3.66571 8.99873 3.58467 8.99992 3.5V0.833333C8.99992 0.744928 8.9648 0.660143 8.90229 0.597631C8.83978 0.535119 8.75499 0.5 8.66659 0.5H5.77992C2.57992 0.5 2.33325 3.23333 2.33325 4.06667V5.16667H0.666585C0.57818 5.16667 0.493395 5.20179 0.430883 5.2643C0.368371 5.32681 0.333252 5.41159 0.333252 5.5V8.16667C0.333252 8.25507 0.368371 8.33986 0.430883 8.40237C0.493395 8.46488 0.57818 8.5 0.666585 8.5H2.33325V16.1667C2.33325 16.2551 2.36837 16.3399 2.43088 16.4024C2.49339 16.4649 2.57818 16.5 2.66659 16.5H5.99992C6.08832 16.5 6.17311 16.4649 6.23562 16.4024C6.29813 16.3399 6.33325 16.2551 6.33325 16.1667V8.5H8.56659C8.64951 8.50042 8.72961 8.46991 8.79124 8.41444C8.85288 8.35896 8.89163 8.28251 8.89992 8.2L9.17992 5.53333C9.18377 5.48741 9.17806 5.44119 9.16314 5.39758C9.14822 5.35398 9.12442 5.31394 9.09325 5.28Z",
    fill: "#2F2F2F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.92b35b047dfba9032876ff5fa369f10b.svg";
export { ForwardRef as ReactComponent };